import { L10N as L10N_BOOKING_DATES } from '../BookingDates/BookingDates.l10n';

const { LABEL_MIN_NIGHTS, LABEL_MIN_NIGHTS_DEALS, LABEL_MIN_NIGHTS_REQUIRED, LABEL_NIGHTS } = L10N_BOOKING_DATES;

export const L10N = {
  ACTION_APPLY: { id: 'common.action.apply' },
  ACTION_CLEAR: { id: 'core.action.clear', defaultMessage: '　' },
  ACTION_LOAD_MORE_DATES: { id: 'core.action.load_more_dates' },
  ACTION_NEXT: { id: 'core.action.next' },
  ACTION_SEARCH: { id: 'common.action.search', defaultMessage: '　　　　' },

  LABEL_ACCOMMODATION_TYPE: { id: 'common.label.accommodation_type' },
  LABEL_ADULTS_AND_CHILDREN: { id: 'common.label.adults_and_children' },
  LABEL_INFO_PRICES: { id: 'core.label.info_prices', defaultMessage: '　' },
  LABEL_INFO_PRICES_WITH_GUESTS: { id: 'core.label.info_prices_with_guests', defaultMessage: '　' },
  LABEL_MIN_NIGHTS,
  LABEL_MIN_NIGHTS_DEALS,
  LABEL_MIN_NIGHTS_REQUIRED,
  LABEL_NIGHTS,
  LABEL_OCCUPATION_TYPE_GUEST: { id: 'common.label.occupation_type_guest', defaultMessage: '　' },
  LABEL_PRICE: { id: 'common.label.price' },
  LABEL_SELECT_DATES_PERSONS: { id: 'core.label.select_dates_persons', defaultMessage: '　　　　　　' },
  LABEL_WHEN: { id: 'core.label.when', defaultMessage: '　　　　' },

  NOTIFICATION_SELECT_DATES: { id: 'core.notification.select_dates' },
};
